import dayjs, { Dayjs } from 'dayjs'
import { calenderPageTypes, DateType } from '../Types'
const todaysDate = dayjs()
export const getLeadingDays = (date: Dayjs, selectableDaysRange = 30): DateType[] => {
    const result = []
    let currentDate = date.date(1)
    let weekday = currentDate.day()
    // loop till monday is reached (1 = monday / 0 = sunday)
    while (weekday !== 1) {
        currentDate = currentDate.subtract(1, 'day')
        weekday = currentDate.day()
        const key =
            currentDate.isBefore(todaysDate.subtract(selectableDaysRange, 'day')) ||
            currentDate.isAfter(todaysDate.add(selectableDaysRange, 'day'))
                ? 'LEADING_DAY_INACTIVE'
                : 'LEADING_DAY_ACTIVE'
        result.push({ value: currentDate.date(), key, date: currentDate })
    }
    return result
}

export const getPadding = (dateBlocksDimension: number) => {
    if (dateBlocksDimension === 40) return 3
    if (dateBlocksDimension === 60) return 6
    return 5
}

export const getMonthDays = (date: Dayjs, selectableDaysRange = 30): DateType[] => {
    const result = []
    const lastDay = date.daysInMonth()

    for (let i = 1; i <= lastDay; i++) {
        const dateOfItem = date.date(i)
        const key =
            todaysDate.subtract(selectableDaysRange, 'day').isAfter(dateOfItem) ||
            dateOfItem.isAfter(todaysDate.add(selectableDaysRange, 'day'))
                ? 'DAY_INACTIVE'
                : 'MONTH_DAY_RANGE'

        result.push({
            value: i,
            key,
            date: dateOfItem,
            isToday: todaysDate.isSame(dateOfItem, 'day'),
        })
    }
    return result
}

export const getTrailingDays = (
    leadingDays: DateType[],
    monthDays: DateType[],
    date: Dayjs,
    selectableDaysRange = 30
): DateType[] => {
    const result = []
    const numberOfVisibleDates = 42
    // To cover Each calender page there have to be 42 date
    // due to month's start day (e.g Thursday) all dates before this day to cover till Monday will be leadingDays
    // whatever remains will be trailingDays
    const days = numberOfVisibleDates - (leadingDays.length + monthDays.length)
    for (let i = 1; i <= days; i++) {
        const dateOfItem = date.add(1, 'month').date(i)
        const key =
            dateOfItem.isAfter(todaysDate.add(selectableDaysRange, 'day')) ||
            dateOfItem.isBefore(todaysDate.subtract(selectableDaysRange, 'day'))
                ? 'TRAILING_DAY_INACTIVE'
                : 'TRAILING_DAY_ACTIVE'
        result.push({ value: i, key, date: dateOfItem })
    }
    return result
}

export const getCalenderPageDays = ({ date, selectableDaysRange }: calenderPageTypes) => {
    const leadingDays = getLeadingDays(date, selectableDaysRange)
    const monthDays = getMonthDays(date, selectableDaysRange)
    const trailingDays = getTrailingDays(leadingDays, monthDays, date, selectableDaysRange)
    return leadingDays.concat(monthDays).concat(trailingDays)
}
